import React from 'react';

import './styles.css';

import { FaUserSlash } from 'react-icons/fa';

export default function AccessCardItem(props) {
    return (
        <li className='access-card-item'>
            <div className='access-card-item-link'>
                <p className='tipo'>{props.tipo}</p>
            </div>
            <button
                type='button'
                className='red'
                onClick={props.unlink}
            >
                <FaUserSlash />
            </button>
        </li>
    )
}